/**
 * (Группа 11/Reports) Отчёты.
 *
 * TODO backend: endpoint'ов отчётов (usage / financial / SLA / vendor) пока
 * нет. UI-каркас каталога и конструктора.
 */
import { PageStub } from '../../shared/PageStub.js';

export function ReportsPage(): JSX.Element {
  return (
    <PageStub
      testId="reports-page"
      title="Отчёты"
      description="Каталог отчётов и конструктор пользовательских отчётов."
      sections={[
        'Каталог отчётов: usage / финансы / SLA breach / эффективность поставщиков',
        'Отчёт usage: активность сотрудников, объём API-вызовов, хранилище per-tenant',
        'Финансовый отчёт: MRR/ARR, когорты, возвраты, просроченные счета',
        'Конструктор пользовательских отчётов',
      ]}
      dataSource="TODO backend: endpoint'ы отчётов отсутствуют"
    />
  );
}
